export type WelcomeDelivery1Props = {
  onContinue?: () => void;
};

export type WelcomeDelivery1ScreenModel = {
  onContinue?: () => void;
};

export function createWelcomeDelivery1ScreenModel(
  props: WelcomeDelivery1Props,
): WelcomeDelivery1ScreenModel {
  return {
    onContinue: props.onContinue,
  };
}
